import React from 'react';

export const STATUS_META = {
  nouveau: { label: 'Nouveau', dotClass: 'bg-orange-500', pillClass: 'bg-orange-100 text-orange-700' },
  lu:      { label: 'Lu',      dotClass: 'bg-blue-500',   pillClass: 'bg-blue-100 text-blue-700' },
  traite:  { label: 'Traité',  dotClass: 'bg-green-500',  pillClass: 'bg-green-100 text-green-700' },
};

export const StatusBadge = ({ status }) => {
  const meta = STATUS_META[status] || STATUS_META.nouveau;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium ${meta.pillClass}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${meta.dotClass}`}></span>
      {meta.label}
    </span>
  );
};

export const StatusFilters = ({ counts, active, onChange }) => {
  const tabs = [
    { key: 'all', label: 'Tous' },
    { key: 'nouveau', label: 'Nouveaux' },
    { key: 'lu', label: 'Lus' },
    { key: 'traite', label: 'Traités' },
  ];
  return (
    <div className="flex flex-wrap gap-2 mb-4" data-testid="status-filters">
      {tabs.map((tab) => {
        const count = counts[tab.key] || 0;
        const isActive = active === tab.key;
        return (
          <button
            key={tab.key}
            onClick={() => onChange(tab.key)}
            className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
              isActive
                ? 'bg-gray-900 text-white'
                : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'
            }`}
            data-testid={`filter-${tab.key}`}
          >
            {tab.label}
            <span className={`ml-1.5 text-xs ${isActive ? 'text-gray-300' : 'text-gray-400'}`}>{count}</span>
          </button>
        );
      })}
    </div>
  );
};
